let wishlist = JSON.parse(localStorage.getItem('wishlist'));
if (wishlist === null) {
  wishlist = [];
}

$(document).ready(function() {
  // Prevent FOUT
  document.fonts.ready.then(function () {
  	$('body').addClass('loaded');
  });
  
  //build dropdown
  $("<select />").appendTo("#navigation nav");

  // Create default option "Go to..."
  $("<option />", {
    "selected": "selected",
    "value"   : "",
    "text"    : "Kunstwerke entdecken"
  }).appendTo("nav select");	

  // Populate dropdowns with the first menu items
  $("ul#nav li a").each(function() {
    var el = $(this);
    var oclass = "";
    var submenu_prefix = "- ";
    if (el.next().hasClass('down')) {
      oclass = "parent";
      submenu_prefix = "";
    }
    $("<option />", {
      "value"   : el.attr("href"),
      "text"    : submenu_prefix + el.text(),
      "class"	  : oclass
    }).appendTo("nav select");
  });

  //make responsive dropdown menu actually work			
  $("nav select").change(function() {
    window.location = $(this).find("option:selected").val();
  });
  
  // Mobile menu
  $('#mobile-menu').on('click', function() {
    let $body = $('body');
    let $mobileMenu = $('.shifter-navigation');
    if ($body.hasClass('shifter-open')) {
      $body.removeClass('shifter-open');
    } else {
      $body.addClass('shifter-open');
      $mobileMenu.removeClass('hide');
    }
  });
  
  $('#page-container .overlay').on('click', function() {
    let $mobileMenu = $('.shifter-navigation');
    $('body').removeClass('shifter-open');
    setTimeout(function() {
      $mobileMenu.addClass('hide');
    }, 400);
  });
  
  $('.accordion-toggle.is-parent').on('click', function() {
    let $this = $(this);
    let $parentUl = $(this).closest('.accordion-content');
    
    $this.next().slideToggle('fast');
    $(".accordion-content").not($(this).next()).not($(this).closest('.accordion-content')).slideUp('fast');
    
//     console.log($parentUl);
//     $this.next().slideToggle('fast');
//     $(".accordion-content").each(function() {
//       console.log($(this));
//       if (!$(this).is($parentUl)) {
//         $(this).not($(this).next()).slideUp('fast')
//       }
//     });
    
//     $(this).next().slideToggle('fast');
//     $(".accordion-content").not($(this).next()).slideUp('fast');
  });

  $(".fancybox").fancybox();

  $('.flexslider').flexslider({
    animation: "slide",
    controlNav: true,
    slideshowSpeed: 5000,
    directionNav: true
  });

  $('.coll-filter').customSelect();


  $('.product').hover(function(){ $(this).children('#product-info').show(); }, function(){ $(this).children('#product-info').hide(); })

  $('#side-select select').on('change', function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  //<![CDATA[
  jQuery(function() {
    jQuery('#sidebar ul li a').each(function() {
      if (jQuery(this).attr('href')  ===  window.location.pathname) {
        jQuery(this).addClass('current');
      }
    });
  });  
  //]]>
  
  $('.main-actions #add').on('click', function() {
    $('#product-description .product-form').submit();
  });

  // Wishlist
  $('.add-to-wishlist').on('click', function(e) {
    e.preventDefault();
    let id = $('form input[name=id]').val();
    let title = $('#product-description > h1').text();
    let price = $(this).attr('data-price');
    let image = $('#img_01').attr('src').replace("_grande.jpg", "_medium.jpg");
    
    if (typeof id === 'undefined') {
      id = $('form select[name=id]').val();
    }
    
    if (isInWishlist(title)) {
      removeWishlistItem(title);
      $('.add-to-wishlist').text('Auf die Merkliste');
      $('.ajaxified-cart-feedback').remove();
      return;
    }
    
    let wishlist_item = {
      "title": title,
      "image": image,
      "link": window.location.pathname,
      "price": price,
      "id": id
    };
    wishlist.push(wishlist_item);
    wishlist_json = JSON.stringify(wishlist);
	localStorage.setItem('wishlist', JSON.stringify(wishlist));
    $(this).text('Von der Merkliste entfernen');
    $(this).parent().append('<p class="ajaxified-cart-feedback success"><i class="fa fa-check"></i> zur Merkliste hinzugefügt! <a href="/pages/merkliste" class="show">Merkliste ansehen</a> oder <a href="/collections/all" class="show">weitersuchen</a></p>');
    updateTopWishlist();
  });
  
  if ($('#shopping-wishlist').length > 0) {
  	createWishlist();
  }
  
  if ($('.add-to-wishlist').length > 0) {
    let title = $('#product-description > h1').text();
    if (isInWishlist(title)) {
      $('.add-to-wishlist').text('Von der Merkliste entfernen');
    } else {
      $('.add-to-wishlist').text('Auf die Merkliste');
    }
    $('.add-to-wishlist').removeClass('hidden');
  }
  
  if ($(window).width() < 740) {
    // Switch filters and description on product data for mobile phones
    $('#collection-description').insertAfter('#nav-border');

    $("#sidebar > h1").addClass('sidebar-h1-responsive');
    $("#sidebar > h1").insertBefore("#collection-description > h1");
    
    // Replace letters
//     replaceElementByText('ü', 'ue');
//     replaceElementByText('ü', 'ue');
//     replaceElementByText('Ü', 'Ue');
//     replaceElementByText('ö', 'oe');
//     replaceElementByText('ö', 'oe');
//     replaceElementByText('Ö', 'Oe');
//     replaceElementByText('ä', 'ae');
//     replaceElementByText('Ä', 'Ae');
  }
});

function replaceElementByText(searchvalue, newvalue) {
  var forbidden = ['SCRIPT', 'META', 'TITLE'];
  var jSpot = $("*:contains(" + searchvalue + ")")
    .filter(function() { return $(this).children().length === 0;});

  jSpot.each(function(i, e) {
  	if (!forbidden.includes($(this).prop('tagName'))) {
      $(this).text($(this).text().replace(searchvalue, newvalue));
      console.log($(this));
  	}
  });
}

function updateTopWishlist() {
  $('#top-wishlist span').text(wishlist.length);
}

function isInWishlist(title) {
  if (wishlist !== null) {
    for (let i = 0; i < wishlist.length; i++) {
      if (wishlist[i].title == title) {
        return true;
      }
    }
  }
  return false;
}

function createWishlist() {
  if (wishlist.length > 0) {
    let table = '<table id="wishlist-table"><thead><tr><th>Kunstwerk</th><th style="text-align: center;">Preis</th><th style="text-align: center;">Entfernen</th></tr></thead><tbody></tbody></table>';
    $('#shopping-wishlist').append(table);
    
    for (let i = 0; i < wishlist.length; i++) {
      let item = "<tr id=\"wishlist_item_"+wishlist[i].id+"\"><input type=\"hidden\" name=\"updates[]\" id=\"updates_"+wishlist[i].id+"\" min=\"0\"><td><div class=\"cart-item\"><div class=\"cart-image\"><a href=\""+wishlist[i].link+"\" title=\""+wishlist[i].title+"\"><img src=\""+wishlist[i].image+"\" alt=\""+wishlist[i].title+"\"></a></div><div class=\"cart-title\"><p>"+wishlist[i].title+"</p></div></div></td><td><p style=\"text-align: center;\">"+wishlist[i].price+"</p></td><td style=\"text-align: center\"><p><a href=\"#\" class=\"remove-from-wishlist\" data-title=\""+wishlist[i].title+"\">X</a></p></td></tr>";
      $('#wishlist-table tbody').append(item);
    }
  } else {
    let not_found = '<p>Auf Ihrer Merkliste befinden sich derzeit keine Werke.</p><div id="search-bar" style="margin-bottom: 30px"><form action="/search" method="get"><h3>Durchsuchen Sie KUNST-ONLINE</h3> <input type="text" name="q" id="q" placeholder="suche..."><input type="hidden" name="type" value="product"></form></div>';
    $('#shopping-wishlist').append(not_found);
  }
  
  $('.remove-from-wishlist').on('click', function(e) {
    let title = $(this).attr('data-title');
    removeWishlistItem(title);
  });
}

function removeWishlistItem(title) {
  if (wishlist !== null) {
    for (let i = 0; i < wishlist.length; i++) {
      if (wishlist[i].title == title) {
        wishlist.splice(i, 1);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        $('#wishlist-table tbody .cart-title:contains('+title+')').closest('tr').remove();
        updateTopWishlist();
        break;
      }
    }
  }
  
  if (wishlist.length == 0) {
    let not_found = '<p>Auf Ihrer Merkliste befinden sich derzeit keine Werke.</p><div id="search-bar" style="margin-bottom: 30px"><form action="/search" method="get"><h3>Durchsuchen Sie KUNST-ONLINE</h3> <input type="text" name="q" id="q" placeholder="suche..."><input type="hidden" name="type" value="product"></form></div>';
    $('#wishlist-table').remove();
    $('#shopping-wishlist').append(not_found);
  }
}






// back to top elfsight
setTimeout(function() {
  var scrollHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  );
  
  var btnTop = document.querySelector('.kNhprh');

  if (btnTop) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > scrollHeight / 2) {
        btnTop.style.opacity = 1;      
      } else {
        btnTop.style.opacity = 0;
      }
    })
  }
}, 3000);

